<template>
  <div class="legal-document">
    <div class="doc-header">
      <h1 class="doc-title">隱私權政策及會員服務條款</h1>
      <div class="doc-meta">
        <div class="meta-row">
          <span class="meta-label">適用網站：</span>
          <span class="meta-value">LOINC、SNOMED CT、RxNorm、THDS、THAS、THRS以及臺灣醫療資訊標準大平台 （合稱「本平台」）</span>
        </div>
        <div class="meta-row">
          <span class="meta-label">生效日期：</span>
          <span class="meta-value">民國115年8月17日</span>
        </div>
      </div>
      <div class="doc-intro">
        <p>歡迎您使用本平台服務。本平台由衛生福利部委託財團法人工業技術研究院辦理，七個網站採共用會員帳號機制，您只需註冊一次，即可使用同一組帳號登入本平台各網站。</p>
        <p>本文件分為兩部分：</p>
        <ul class="intro-list">
          <li><strong>第一部分「隱私權政策」</strong>，說明本平台如何蒐集、處理、保護及利用您的個人資料，以及您所享有的權利。</li>
          <li><strong>第二部分「會員服務條款」</strong>，規範您使用本平台共用會員帳號及服務之基本權利義務。</li>
        </ul>
        <p>請您在註冊或使用本平台服務前詳細閱讀。您完成註冊或繼續使用本平台服務，即表示您已閱讀、瞭解並同意本文件之內容。</p>
      </div>
    </div>

    <!-- 第一部分 隱私權政策 -->
    <section class="doc-section" id="privacy-policy">
      <h2 class="section-title">第一部分　隱私權政策</h2>

      <div class="article-block">
        <h3 class="article-title">一、本政策的適用範圍</h3>
        <p>本政策適用於您使用本平台七個網站（LOINC、SNOMED CT、RxNorm、THDS、THAS、THRS以及臺灣醫療資訊標準大平台）之全部服務，包括共用會員帳號之註冊與使用。</p>
        <p>本平台網頁可能提供其他網站之連結。您點選連結進入該等網站後，其隱私權保護措施由各該網站負責，不適用本政策。</p>
      </div>

      <div class="article-block">
        <h3 class="article-title">二、我們蒐集哪些資料</h3>
        
        <h4 class="sub-article-title">（一）您註冊會員時提供的資料</h4>
        <div class="table-responsive">
          <table class="legal-table">
            <thead>
              <tr>
                <th style="width: 50%;">資料項目</th>
                <th style="width: 50%;">必填/選填</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>電子信箱</td>
                <td>必填</td>
              </tr>
              <tr>
                <td>密碼</td>
                <td>必填</td>
              </tr>
              <tr>
                <td>姓名</td>
                <td>必填</td>
              </tr>
              <tr>
                <td>手機號碼</td>
                <td>必填</td>
              </tr>
              <tr>
                <td>所屬單位</td>
                <td>選填</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="table-note">上述資料為本平台各網站共同使用，您不需要在每個網站重複填寫。</p>

        <h4 class="sub-article-title">（二）您使用特定服務時提供的資料</h4>
        <p>本平台各網站的服務內容不同，當您申請下列服務時，我們會另外請您提供必要資料：</p>
        <div class="table-responsive">
          <table class="legal-table">
            <thead>
              <tr>
                <th style="width: 25%;">服務</th>
                <th style="width: 25%;">適用網站</th>
                <th style="width: 50%;">我們會蒐集</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>API申請及標準下載</td>
                <td>LOINC、SNOMED CT、RxNorm</td>
                <td>姓名、所屬單位/組織、職業、標準使用模式、主要用途、預計使用之系統；另需上傳您簽署之保密協議，其中包含姓名、國民身分證統一編號、聯絡電話、戶籍地址及所屬組織資料</td>
              </tr>
              <tr>
                <td>標準提案</td>
                <td>LOINC、RxNorm</td>
                <td>姓名、提案機構名稱、手機號碼、電子信箱及提案資料</td>
              </tr>
              <tr>
                <td>個人證書下載</td>
                <td>LOINC、SNOMED CT、RxNorm</td>
                <td>姓名、國民身分證統一編號及資格證明資料</td>
              </tr>
              <tr>
                <td>實作指引及資料規格提案</td>
                <td>THDS</td>
                <td>提案機構名稱、提案人姓名、服務組織/單位及電子信箱</td>
              </tr>
              <tr>
                <td>SMART App 提案</td>
                <td>THAS</td>
                <td>組織/機構名稱、開發者姓名及電子郵件、行政聯絡人電子郵件、業務聯絡人電子郵件</td>
              </tr>
              <tr>
                <td>CQL 提案</td>
                <td>THRS</td>
                <td>提案者姓名、電子信箱、服務組織/單位</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="table-note">您在各服務的申請頁面，會看到該次蒐集資料的詳細說明。</p>

        <h4 class="sub-article-title">（三）系統自動記錄的資料</h4>
        <p>當您瀏覽本平台時，伺服器會自動記錄您的IP位址、使用時間、瀏覽器類型、作業系統、瀏覽及點選紀錄，以及API呼叫紀錄。這些資料用於系統維運、流量分析及資通安全維護，不會用於識別特定個人的身分。</p>
      </div>

      <div class="article-block">
        <h3 class="article-title">三、我們如何使用您的資料</h3>

        <h4 class="sub-article-title">（一）共同使用目的</h4>
        <ul class="legal-list">
          <li>建立及管理您的共用會員帳號</li>
          <li>進行登入及身分驗證</li>
          <li>提供會員服務及寄送必要通知（例如：申請結果、系統公告、服務變更通知）</li>
          <li>維護帳號安全及資通安全</li>
          <li>處理您的諮詢、申訴及個人資料權利行使之請求</li>
        </ul>

        <h4 class="sub-article-title">（二）各服務之使用目的</h4>
        <ul class="legal-list">
          <li><strong>API申請及標準下載：</strong> 確認申請人及所屬組織身分、審查使用資格與用途、辦理保密協議簽署、開通API權限及提供標準下載</li>
          <li><strong>標準提案、實作指引及資料規格提案、SMART App提案、CQL提案：</strong> 確認提案人及提案機構身分、受理及審查提案、辦理聯繫、補件及結果通知</li>
          <li><strong>個人證書下載：</strong> 確認證書取得資格並提供證書下載</li>
        </ul>
        <p>我們不會將您的個人資料用於上述目的以外之用途；如有必要，將另行取得您的同意。</p>
      </div>

      <div class="article-block">
        <h3 class="article-title">四、共用會員帳號的資料如何跨網站使用</h3>
        <p>本平台七個網站均由衛生福利部委託財團法人工業技術研究院辦理，屬同一個資料管理主體。因此：</p>
        <div class="callout-block">
          <ol class="legal-ol">
            <li>您註冊時提供的基本資料，會在本平台七個網站間共同使用，作為登入、身分驗證及提供會員服務之用。這<strong>不是</strong>將您的資料提供給第三人。</li>
            <li>您在特定網站或特定服務所填寫的資料（例如：API申請表單、提案資料），原則上<strong>只用於該項服務</strong>，不會作為其他網站服務之用；除非法令另有規定或經您同意。</li>
            <li>您更新基本資料時，更新內容會同步適用於本平台各網站。</li>
          </ol>
        </div>
      </div>

      <div class="article-block">
        <h3 class="article-title">五、我們如何保護您的資料</h3>
        <p>本平台採取下列措施保護您的個人資料：</p>
        <ul class="legal-list">
          <li><strong>傳輸加密：</strong> 網站採用加密連線傳輸資料</li>
          <li><strong>密碼保護：</strong> 您的密碼經加密後儲存，本平台人員無法讀取您的原始密碼</li>
          <li><strong>存取控管：</strong> 僅授權必要人員得存取個人資料，並留存存取紀錄</li>
          <li><strong>加強保護：</strong> 就國民身分證統一編號等敏感度較高之資料，另採行加強之存取控管及保存管理措施</li>
          <li><strong>人員管理：</strong> 相關人員均負有保密義務</li>
          <li><strong>系統維護：</strong> 定期進行系統更新及安全檢測</li>
        </ul>
        <p>惟網際網路傳輸無法保證絕對安全。本平台將盡善良管理人之注意義務維護資料安全，如因不可歸責於本平台之事由發生資料外洩，本平台不負賠償責任；若發生個人資料外洩事故，本平台將依法查明並以適當方式通知您。</p>
      </div>

      <div class="article-block">
        <h3 class="article-title">六、我們會在什麼情況下提供您的資料給他人</h3>
        <p>本平台<strong>不會</strong>任意將您的個人資料提供給無關的第三人。僅於下列情形，我們會提供必要範圍內之資料：</p>
        <div class="callout-block">
          <ol class="legal-ol">
            <li><strong>經您同意時。</strong></li>
            <li><strong>委外服務廠商。</strong> 為提供本平台服務，我們可能委託廠商協助處理（例如：系統維運、雲端主機、電子郵件發送）。我們會依法對受託廠商為適當監督，並以契約約定其個人資料保護義務。</li>
            <li><strong>依法令規定。</strong> 司法機關、主管機關或其他有權機關依法要求提供時。</li>
            <li><strong>保護權益之必要。</strong> 為維護本平台或其他使用者之權益，且符合法令規定時。</li>
          </ol>
        </div>
      </div>

      <div class="article-block">
        <h3 class="article-title">七、我們保存您的資料多久</h3>
        <div class="callout-block">
          <ol class="legal-ol">
            <li>於前述使用目的之必要期間內保存。</li>
            <li>法令規定應保存者，依各該法令規定之期間。</li>
            <li>您申請刪除帳號或本平台停止提供服務時，將依規定刪除或銷毀；但依法令應繼續保存者，不在此限。</li>
          </ol>
        </div>
      </div>

      <div class="article-block">
        <h3 class="article-title">八、您享有的權利</h3>
        <p>依個人資料保護法第三條規定，您就本平台保有之個人資料，得行使下列權利：</p>
        <div class="table-responsive">
          <table class="legal-table">
            <thead>
              <tr>
                <th style="width: 35%;">權利</th>
                <th style="width: 65%;">說明</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>查詢、閱覽</td>
                <td>查詢本平台是否保有您的資料，並請求閱覽</td>
              </tr>
              <tr>
                <td>製給複製本</td>
                <td>請求提供您個人資料之複製本</td>
              </tr>
              <tr>
                <td>補充、更正</td>
                <td>請求補充或更正錯誤之資料</td>
              </tr>
              <tr>
                <td>停止蒐集、處理或利用</td>
                <td>請求本平台停止蒐集、處理或利用您的資料</td>
              </tr>
              <tr>
                <td>刪除</td>
                <td>請求刪除您的個人資料</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p><strong>行使方式：</strong> 您可透過會員專區、客服信箱或書面方式提出申請。我們會依個人資料保護法規定之期限處理並回覆。</p>
        <p><strong>請注意：</strong></p>
        <div class="callout-block">
          <ol class="legal-ol">
            <li>部分資料（例如電子信箱、姓名）是提供會員服務所必需。若您請求刪除或停止處理利用該等資料，我們將無法繼續提供服務，並可能須終止您的會員帳號。</li>
            <li>因本平台採共用會員帳號機制，您請求刪除基本資料或註銷帳號時，其效力會及於本平台全部七個網站。若您只是不想使用某個網站，可直接停止使用該網站，不需註銷帳號。</li>
            <li>依個人資料保護法第十條、第十一條規定，如有法定事由，本平台得拒絕您的請求，並會向您說明理由。</li>
            <li>本平台受理查詢、閱覽或製給複製本之請求時，得酌收必要成本費用。</li>
          </ol>
        </div>
      </div>

      <div class="article-block">
        <h3 class="article-title">九、不提供資料的影響</h3>
        <p>您可以自由選擇是否提供個人資料。但：</p>
        <ul class="legal-list">
          <li>標示為<strong>必填</strong>的欄位，是提供各該服務所必需。若您未提供或提供不完整，我們將無法完成您的註冊，或無法提供各該服務。</li>
          <li>標示為<strong>選填</strong>的欄位，您可以選擇不提供，不影響基本會員服務之使用；但可能影響部分功能之使用或審查作業之進行。</li>
        </ul>
        <p>各服務的必填欄位及未提供之影響，會在該服務的申請頁面說明。</p>
      </div>
    </section>

    <!-- 第二部分 會員服務條款 -->
    <section class="doc-section" id="terms-of-service">
      <h2 class="section-title">第二部分　會員服務條款</h2>

      <div class="article-block">
        <h3 class="article-title">十一、文件架構與適用範圍</h3>
        <div class="callout-block">
          <ol class="legal-ol">
            <li>本部分規範您使用本平台共用會員帳號及各網站服務之基本權利義務。</li>
            <li>本平台各網站因服務內容不同，所蒐集之個人資料亦有差異。各網站於提供特定服務時所蒐集之個人資料項目、蒐集目的及相關注意事項，詳如各網站個人資料蒐集補充說明。該補充說明為本文件之一部分，與本文件具有同等效力；其規定與本文件不一致時，於各該網站之範圍內優先適用。</li>
            <li>本平台各網站之服務內容、技術規格、申請資格條件、審查程序、標準內容授權條款及提案內容權利歸屬等事項，由本平台另行規範，不屬本文件之範圍。</li>
          </ol>
        </div>
      </div>

      <div class="article-block">
        <h3 class="article-title">十二、共用會員帳號</h3>
        <div class="callout-block">
          <ol class="legal-ol">
            <li>您於任一網站完成註冊後，即得以同一組帳號登入本平台其他網站，無須重複註冊。</li>
            <li>您首次進入本平台其他網站時，如該網站服務需要額外之個人資料，應依該網站之要求補充提供，並確認該網站之個人資料蒐集補充說明。</li>
            <li>您已提供之基本資料，於本平台各網站間共同適用，無須重複填寫。</li>
          </ol>
        </div>
      </div>

      <div class="article-block">
        <h3 class="article-title">十三、註冊、帳號安全與會員義務</h3>
        <div class="callout-block">
          <ol class="legal-ol">
            <li>註冊時，您應提供正確、最新及完整之資料，並於資料變更時即時更新。因您未提供正確資料或未即時更新所生之不利益，由您自行承擔。</li>
            <li>您不得使用他人名義或虛偽資料註冊，亦不得冒用他人身分或所屬組織名義申請服務。</li>
            <li>您僅得註冊一組共用會員帳號。</li>
            <li>您應妥善保管帳號及密碼，不得提供、洩漏或轉讓予第三人使用。凡使用您的帳號及密碼所為之一切行為，均視為您本人之行為。如您發現帳號或密碼遭他人非法使用，應立即通知本平台；本平台於接獲通知後將採取必要處理措施，但對於通知前已發生之損害不負責任。</li>
            <li>您使用本平台服務時，不得有下列行為：
              <ul class="sub-list-disc">
                <li>違反中華民國法令、本文件或本平台公告之相關規定</li>
                <li>未經授權而使用、重製、散布、公開傳輸或改作本平台提供之標準內容、資料規格、實作指引或其他資料</li>
                <li>以自動化程式、爬蟲或其他非正常方式大量存取本平台或其應用程式介面（API）</li>
                <li>破解、規避或試圖規避本平台之技術保護措施或存取控制機制</li>
                <li>提供不實資料、偽造文件，或以不正當方式取得服務權限</li>
                <li>侵害本平台、其他會員或任何第三人之智慧財產權、隱私權或其他權利</li>
                <li>從事影響本平台正常運作，或危害資通安全之行為</li>
              </ul>
            </li>
          </ol>
        </div>
      </div>

      <div class="article-block">
        <h3 class="article-title">十四、各網站服務之個別規範</h3>
        <div class="callout-block">
          <ol class="legal-ol">
            <li>本平台各網站就服務內容、申請資格、審查程序及使用限制，各有不同規範，依本平台另行公告之規定辦理。</li>
            <li>三個醫療標準網站（LOINC、SNOMED CT、RxNorm）所提供之標準內容，其使用受各該國際標準機構授權條款之拘束。您申請使用前，應詳閱並遵守各該授權條款。</li>
            <li>部分服務功能（如API申請、標準下載、個人證書下載）須另行申請並經審查通過後方得使用，並可能須簽署保密協議或其他文件。各該服務所蒐集之個人資料，詳如附錄A至附錄F。</li>
          </ol>
        </div>
      </div>

      <div class="article-block">
        <h3 class="article-title">十五、智慧財產權</h3>
        <div class="callout-block">
          <ol class="legal-ol">
            <li>本平台所使用之軟體、程式、網站架構、畫面編排、網頁設計及其他內容，其智慧財產權均屬本平台或權利人所有。</li>
            <li>本平台所提供之醫療標準內容（包括但不限於 LOINC、SNOMED CT、RxNorm），其權利歸屬各該國際標準機構所有，並依各該機構之授權條款使用。</li>
            <li>未經本平台或權利人事前書面同意，您不得以任何方式重製、公開傳輸、改作、散布、出租、出借、販售或為其他侵害智慧財產權之行為。</li>
          </ol>
        </div>
      </div>

      <div class="article-block">
        <h3 class="article-title">十六、服務之變更、中斷與終止</h3>
        <div class="callout-block">
          <ol class="legal-ol">
            <li>本平台得因業務需要、系統維護、法令變更或其他正當事由，變更、暫停或終止本平台全部或一部服務。</li>
            <li>前項情形，本平台將以適當方式於合理期間前公告或通知；但因不可抗力、緊急狀況或其他不可歸責於本平台之事由，不在此限。</li>
            <li>因系統維護更新、電信線路或第三方服務故障、天災事變或其他不可抗力事由致服務中斷者，本平台不負賠償責任。</li>
          </ol>
        </div>
      </div>

      <div class="article-block">
        <h3 class="article-title">十七、帳號停權與終止</h3>
        <div class="callout-block">
          <ol class="legal-ol">
            <li>您有下列情形之一者，本平台得視情節輕重，暫停或終止您使用全部或一部服務之權利，並得刪除相關內容：
              <ul class="sub-list-disc">
                <li>違反本文件或本平台公告之相關規定</li>
                <li>違反國際標準機構授權條款或所簽署之保密協議</li>
                <li>提供不實資料或以不正當方式取得服務權限</li>
                <li>違反中華民國法令</li>
                <li>其他經本平台認定有必要之情形</li>
              </ul>
            </li>
            <li>本平台依前項規定處置時，將以電子郵件或其他適當方式通知您並說明理由；但情況急迫或依法令不得通知者，不在此限。您對處置有異議者，得依本平台公告之方式提出申訴。</li>
          </ol>
        </div>
      </div>

      <div class="article-block">
        <h3 class="article-title">十八、帳號註銷</h3>
        <div class="callout-block">
          <ol class="legal-ol">
            <li>您得隨時申請註銷共用會員帳號。</li>
            <li>因本平台採共用會員帳號機制，帳號註銷之效力及於本平台全部七個網站。您如僅欲停止使用特定網站之服務，得改以停止使用該網站之方式為之，無須註銷帳號。</li>
            <li>帳號註銷後，您原有之申請權限、下載權限及提案紀錄將一併終止，本平台不負回復之責。</li>
            <li>帳號註銷後，您個人資料之處理，依第壹部分第七點及第八點辦理。</li>
            <li>您於使用本平台服務期間所簽署之保密協議，其效力不因帳號註銷而受影響。</li>
          </ol>
        </div>
      </div>

      <div class="article-block">
        <h3 class="article-title">十九、免責聲明</h3>
        <div class="callout-block">
          <ol class="legal-ol">
            <li>本平台所提供之醫療標準內容、實作指引、資料規格及其他資料，僅供參考使用。您應自行評估其適用性，並就使用結果自負其責。</li>
            <li>本平台不擔保所提供之內容或服務無錯誤、無中斷，或必能滿足您之特定需求。</li>
            <li>本平台可能提供第三方網站之連結。該等網站之內容及服務由各該網站經營者負責，本平台不負任何責任。</li>
            <li>於法令允許之最大範圍內，本平台就您使用本平台服務所生之間接損害、附隨損害或衍生損害，不負賠償責任。</li>
          </ol>
        </div>
      </div>
    </section>

    <!-- 第三部分 共同事項 -->
    <section class="doc-section" id="common-provisions">
      <h2 class="section-title">第三部分　共同事項</h2>

      <div class="article-block">
        <h3 class="article-title">二十、本文件之修訂</h3>
        <div class="callout-block">
          <ol class="legal-ol">
            <li>本平台得因法令變更、服務調整或其他正當事由，修訂本文件及其附錄。</li>
            <li>修訂時，本平台將以網站公告、電子郵件或其他適當方式通知，並載明修訂內容及生效日期。修訂內容涉及您重大權益者，將於生效日前〔七〕日通知。</li>
            <li>修訂內容如涉及個人資料蒐集目的、個人資料類別或利用方式之重大變更，本平台將另依個人資料保護法規定辦理告知。</li>
            <li>修訂後之內容於生效日起適用。您如不同意修訂內容，得於生效日前停止使用服務或註銷帳號；於生效日後繼續使用服務者，視為同意修訂後之內容。</li>
          </ol>
        </div>
      </div>

      <div class="article-block">
        <h3 class="article-title">二十一、準據法與管轄法院</h3>
        <div class="callout-block">
          <ol class="legal-ol">
            <li>本文件之解釋及適用，以及與本文件有關之爭議，均依中華民國法律為準據法。</li>
            <li>因本文件所生之爭議，以臺灣臺北地方法院為第一審管轄法院；但法律另有專屬管轄規定者，依其規定。</li>
          </ol>
        </div>
      </div>

      <div class="article-block">
        <h3 class="article-title">二十二、其他</h3>
        <div class="callout-block">
          <ol class="legal-ol">
            <li>本文件之任一條款經認定為無效或不可執行者，不影響其他條款之效力。</li>
            <li>本平台未行使或遲延行使本文件所定之權利，不構成對該權利之拋棄。</li>
          </ol>
        </div>
      </div>

      <div class="article-block" id="contact-us">
        <h3 class="article-title">二十三、聯絡我們</h3>
        <p>如您對本文件有任何疑問，或欲行使個人資料相關權利，請透過下列方式與我們聯繫：</p>
        <div class="callout-block contact-card">
          <p class="contact-item"><strong>聯絡單位：</strong> 次世代數位醫療平臺專案辦公室</p>
          <p class="contact-item"><strong>電子信箱：</strong> medstandard＠itri.org.tw</p>
          <p class="contact-item"><strong>聯絡電話：</strong> (02) 8590-6347</p>
          <p class="contact-item"><strong>通訊地址：</strong> 115204 台北市南港區忠孝東路6段488號</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
// Document pure presentation component
</script>

<style scoped>
.legal-document {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  color: #1f2937;
  line-height: 1.8;
  font-size: 15px;
  max-width: 100%;
}

.doc-header {
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 24px;
  margin-bottom: 32px;
}

.doc-title {
  font-size: 28px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 16px 0;
  line-height: 1.3;
}

.doc-meta {
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 14px 18px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.meta-row {
  font-size: 14px;
  display: flex;
  flex-wrap: wrap;
}

.meta-label {
  font-weight: 600;
  color: #475569;
  min-width: 80px;
}

.meta-value {
  color: #1e293b;
}

.doc-intro p {
  margin: 0 0 12px 0;
  color: #334155;
}

.intro-list, .legal-list {
  padding-left: 24px;
  margin: 12px 0 16px 0;
}

.intro-list li, .legal-list li {
  margin-bottom: 8px;
  color: #334155;
}

.doc-section {
  margin-bottom: 40px;
}

.section-title {
  font-size: 22px;
  font-weight: 700;
  color: #0f172a;
  padding-bottom: 10px;
  border-bottom: 2px solid var(--color-primary, #022964);
  margin-top: 36px;
  margin-bottom: 20px;
}

.article-block {
  margin-bottom: 28px;
}

.article-title {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin-top: 24px;
  margin-bottom: 12px;
}

.sub-article-title {
  font-size: 16px;
  font-weight: 600;
  color: #334155;
  margin-top: 18px;
  margin-bottom: 10px;
}

p {
  margin: 0 0 12px 0;
  color: #334155;
}

.table-responsive {
  width: 100%;
  overflow-x: auto;
  margin: 14px 0 8px 0;
  border: 1px solid #d1d5db;
  border-radius: 4px;
}

.legal-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  text-align: left;
}

.legal-table th {
  background-color: #f1f5f9;
  color: #0f172a;
  font-weight: 600;
  padding: 10px 14px;
  border-bottom: 1px solid #cbd5e1;
  border-right: 1px solid #e2e8f0;
}

.legal-table th:last-child {
  border-right: none;
}

.legal-table td {
  padding: 10px 14px;
  border-bottom: 1px solid #e2e8f0;
  border-right: 1px solid #e2e8f0;
  color: #334155;
  line-height: 1.6;
}

.legal-table td:last-child {
  border-right: none;
}

.legal-table tbody tr:last-child td {
  border-bottom: none;
}

.legal-table tbody tr:nth-child(even) {
  background-color: #f8fafc;
}

.table-note {
  font-size: 13px;
  color: #64748b;
  margin-top: 6px;
  margin-bottom: 16px;
}

.callout-block {
  background-color: #f8fafc;
  border-left: 3px solid var(--color-primary, #022964);
  border-radius: 0 4px 4px 0;
  padding: 14px 18px;
  margin: 12px 0 16px 0;
}

.callout-block p {
  margin-bottom: 6px;
}

.callout-block p:last-child {
  margin-bottom: 0;
}

.legal-ol {
  padding-left: 20px;
  margin: 0;
}

.legal-ol > li {
  margin-bottom: 10px;
  color: #334155;
  line-height: 1.7;
}

.legal-ol > li:last-child {
  margin-bottom: 0;
}

.sub-list-disc {
  list-style-type: disc;
  padding-left: 20px;
  margin-top: 8px;
  margin-bottom: 4px;
}

.sub-list-disc li {
  margin-bottom: 6px;
  color: #334155;
}

.contact-card {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.contact-item {
  margin: 0 !important;
  font-size: 14px;
  color: #1e293b;
}

@media (max-width: 768px) {
  .doc-title {
    font-size: 22px;
  }
  .section-title {
    font-size: 19px;
  }
  .article-title {
    font-size: 16px;
  }
  .sub-article-title {
    font-size: 15px;
  }
  .legal-document {
    font-size: 14px;
  }
}
</style>
